import {
  BookOpen,
  MessageSquare,
  Bot,
  Inbox,
  Send,
  BarChart3,
  CreditCard,
  Code,
  MessageCircle,
} from "lucide-react";

interface CategoriesSidebarProps {
  activeCategory?: string;
  onCategoryChange?: (category: string) => void;
}

export function CategoriesSidebar({ activeCategory = "getting-started", onCategoryChange }: CategoriesSidebarProps) {
  const categories = [
    { id: "getting-started", label: "Getting Started", icon: BookOpen, count: 12 },
    { id: "channels", label: "Channels & Setup", icon: MessageSquare, count: 18 },
    { id: "ai-automation", label: "AI & Automation", icon: Bot, count: 24 },
    { id: "conversations", label: "Conversations", icon: Inbox, count: 15 },
    { id: "campaigns", label: "Campaigns", icon: Send, count: 9 },
    { id: "analytics", label: "Analytics", icon: BarChart3, count: 11 },
    { id: "billing", label: "Billing & Plans", icon: CreditCard, count: 7 },
    { id: "api", label: "API & Developers", icon: Code, count: 16 },
  ];

  return (
    <aside className="w-64 flex-shrink-0">
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden sticky top-8">
        {/* Header */}
        <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
          <h3 className="text-sm font-semibold text-gray-900">Browse by Category</h3>
        </div>

        {/* Categories List */}
        <nav className="p-2">
          {categories.map((category) => {
            const Icon = category.icon;
            const isActive = activeCategory === category.id;

            return (
              <button
                key={category.id}
                onClick={() => onCategoryChange?.(category.id)}
                className={`
                  w-full px-3 py-2.5
                  flex items-center gap-3
                  rounded-lg
                  text-sm font-medium
                  mb-1
                  transition-colors
                  ${
                    isActive
                      ? "bg-blue-50 text-blue-700"
                      : "text-gray-700 hover:bg-gray-100"
                  }
                `}
              >
                <Icon className="w-4 h-4" />
                {category.label}
                <span
                  className={`
                    ml-auto text-xs px-2 py-0.5 rounded-full
                    ${isActive ? "bg-blue-100" : "bg-gray-200"}
                  `}
                >
                  {category.count}
                </span>
              </button>
            );
          })}
        </nav>

        {/* Contact Support Button */}
        <div className="p-4 border-t border-gray-200">
          <button className="w-full px-4 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 flex items-center justify-center gap-2 transition-colors">
            <MessageCircle className="w-4 h-4" />
            Contact Support
          </button>
        </div>
      </div>
    </aside>
  );
}
